import type { AuditEntry } from '../../api/platformAudit';
import { actionToTone } from './auditActionPill';
import { StatusBadge } from '../StatusBadge';

interface Props {
  entry: AuditEntry;
  expanded: boolean;
  onToggle: (id: number) => void;
  showTenantColumn: boolean;
}

/**
 * Audit log row. Logic/expansion/props unchanged; markup restyled to Velzon
 * (StatusBadge for the action pill, Bootstrap classes for cells/buttons).
 */
export function AuditRow({ entry, expanded, onToggle, showTenantColumn }: Props) {
  const tone = actionToTone(entry.action);
  const time = entry.occurred_at.slice(11, 19); // "14:32:18"

  return (
    <>
      <tr onClick={() => onToggle(entry.id)} style={{ cursor: 'pointer' }}>
        <td className="font-monospace">{time}</td>
        {showTenantColumn && <td className="font-monospace">{entry.tenant_code ?? '—'}</td>}
        <td>{entry.actor_email ?? '—'}</td>
        <td><StatusBadge tone={tone}>{entry.action}</StatusBadge></td>
        <td className="font-monospace">
          {entry.entity_type ? `${entry.entity_type}#${entry.entity_id ?? '?'}` : '—'}
        </td>
        <td className="text-end">
          <button
            type="button"
            aria-label={expanded ? 'Comprimi' : 'Espandi payload'}
            className="btn btn-sm btn-ghost-secondary"
            onClick={(e) => { e.stopPropagation(); onToggle(entry.id); }}
          >
            <i className={`bi ${expanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
          </button>
        </td>
      </tr>
      {expanded && (
        <tr>
          <td colSpan={showTenantColumn ? 6 : 5} className="p-0 bg-light">
            <pre className="m-0 p-3 bg-dark text-light font-monospace fs-12" style={{ maxHeight: 240, overflow: 'auto' }}>
              {JSON.stringify(entry.payload, null, 2)}
            </pre>
            <div className="d-flex justify-content-end p-2">
              <button
                type="button"
                className="btn btn-sm btn-ghost-secondary"
                onClick={() => navigator.clipboard.writeText(JSON.stringify(entry.payload, null, 2))}
              >
                <i className="bi bi-clipboard me-1" />Copia JSON
              </button>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
